// extracted by mini-css-extract-plugin
export default {"faq-header-section":"FAQHeader_faq-header-section__O+lo1","faq-title":"FAQHeader_faq-title__+YBgh","faq-subtitle":"FAQHeader_faq-subtitle__+Ofkp"};